import { defineStore } from 'pinia'
import { nanoid } from 'nanoid'

export const useToastStore = defineStore('toast', {
  state: () => ({ list: [] }),
  actions: {
    push(message, type = 'info', timeout = 3000) {
      const id = nanoid()
      this.list.push({ id, message, type })
      setTimeout(() => this.remove(id), timeout)
    },
    success(message, timeout = 3000) {
      this.push(message, 'success', timeout)
    },
    error(message, timeout = 3000) {
      this.push(message, 'error', timeout)
    },
    info(message, timeout = 3000) {
      this.push(message, 'info', timeout)
    },
    warning(message, timeout = 3000) {
      this.push(message, 'warning', timeout)
    },
    remove(id) {
      this.list = this.list.filter(t => t.id !== id)
    }

  }
})